import React, {useState} from 'react';
import TabPhotos from '../Tabs/TabPhotos';
import TabUploads from '../Tabs/TabUploads';
import TableGrid from '../StockItems/TableGrid';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

function App(props) {

  const [photoSource, setPhotoSource] = useState(1);
  var srcPath = props.srcPath;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var columnWidth = props.columnWidth;
  var signKey = props.signKey;
  var userID = props.userID;
  var sessionID = props.sessionID;
  var isFromScreen = props.isFromScreen;
  var clickBack = props.clickBack;
  var isNew = props.isNew;
  var setItemEdited = props.setItemEdited;
  var userNos = props.userNos;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;

  function clickImage(url, w, h){

    if (isNew){

      var imgS = {src:url, borderWidth:{t:'int',v:0}};
      var tx = 'IMG';
      if (isNew.addWhereText === 'navBar' || isNew.addWhereText === 'navDropDown'){
        imgS.maxWidth = {t:'px', v:30};
        imgS.maxHeight = {t:'px', v:24};
      }
      if (ResponsiveFns.isRelative(srcPath)){
        imgS.width = {t:'perc', v:100};
        imgS.wh = {t:'int',v:0};
      }
      var item = {t:tx, oc:{}, s:imgS, info:StyleFunctions.imgInfoBaseline(w, h)}; //origW, origH, cropLeft, cropRight, cropTop, cropBottom
      var uuid = CoreFns.uuidCheckEverywhere(userNos, currentList);
      ResponsiveFns.reallyAddItem(item, srcPath, uuid, isNew.position, currentList, organicChanges, [], setItemEdited, isNew.insetWidth, isNew.insetHeight, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems);
      clickBack();
        return;

    }

    var changes1 = [{t:'w',w:srcPath,n:''}];
    if (isFromScreen){
      var objPath = CoreFns.filterPathStopBefore(srcPath, srcPath.length - 2);
      changes1.push({t:'w',w:objPath.concat(['info']),n:StyleFunctions.imgInfoBaseline(w, h)})
      var v = 3;
      // if (photoSource === 2){
      //   v = 0;
      // }
      changes1.push({t:'w',w:objPath.concat(['pos', 'ud']),n:{t:'int',v}})
    }
    organicChanges(changes1);

    setTimeout(function(){ 
        var changes = [{t:'w',w:srcPath,n:url}];
        organicChanges(changes);
        clickBack();
    }, 1);

  }

  var options = [{i:0, t:'Stock', ic:'akar-icons:cloud-download'}, {i:1, t:'Uploads', ic:'akar-icons:cloud-upload'}];
  // if (isFromScreen){
  //   options.push({i:2, n:'Formula'});    
  // }

  var inside;
  if (photoSource === 0){
    inside = <TabPhotos addWhereText={false} nos={3} entityName='IMG' width={columnWidth - 20} clickImage={clickImage} currentImageUrl='' />
  }else if (photoSource === 1){
    inside = <TabUploads addWhereText={false} nos={3} entityName='IMG' width={columnWidth - 20} clickImage={clickImage} currentImageUrl='' signKey={signKey} userID={userID} sessionID={sessionID} />
  }

  function clickPhoto(x){
      setPhotoSource(x.i);
  }
  return <div><center>
     <TableGrid options={options} currentAnswer={photoSource} onClick={clickPhoto} />
    {inside}
    </center>
    </div>
}

      // rows.push(<tr key={rows.length} className={cNameHere} style={{cursor:'pointer'}} onClick={doSRC('IMG')}><td>Image Source</td></tr>)

//
export default App;
